import React from "react";
import { TouchableOpacity } from "react-native";

import Svg, {
  Path,
  G,
  Defs,
  Circle,
  Stop,
  LinearGradient,
  Rect,
  ClipPath,
} from "react-native-svg";

import { isWeb } from "../../../../../helpers/utils";
import AppTheme from "../../../AppTheme";

export default function MariSanta({ onPress, source }) {
  const clipId = "clip0_santa" + source;
  const filterId = "filter0_d_MariSanta" + source;
  const gradientId = "paint0_linear_MariSanta" + source;
  const clipUrl = "url(#" + clipId + ")";
  const filterUrl = "url(#" + filterId + ")";
  const gradientUrl = "url(#" + gradientId + ")";

  return (
    <TouchableOpacity onPress={onPress}>
      <Svg
        width="79"
        height="81"
        viewBox="0 0 79 81"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G filter={filterUrl}>
          <Circle cx="46" cy="44" r="28" fill={gradientUrl} />
          <Path
            d="M40.0698 56.0679C44.5064 58.1736 49.3033 58.7254 53.7962 55.4486"
            stroke="#243251"
            strokeWidth="1.47036"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M34.3946 45.1678C35.9058 45.1678 37.1309 43.9427 37.1309 42.4315C37.1309 40.9203 35.9058 39.6953 34.3946 39.6953C32.8834 39.6953 31.6583 40.9203 31.6583 42.4315C31.6583 43.9427 32.8834 45.1678 34.3946 45.1678Z"
            fill="#243251"
          />
          <Path
            opacity="0.61"
            d="M33.8538 42.0824C34.2394 42.0824 34.552 41.7699 34.552 41.3843C34.552 40.9987 34.2394 40.6862 33.8538 40.6862C33.4683 40.6862 33.1557 40.9987 33.1557 41.3843C33.1557 41.7699 33.4683 42.0824 33.8538 42.0824Z"
            fill="white"
          />
          <Path
            d="M30.3857 35.8216C31.4636 35.0162 32.74 34.5185 34.0786 34.3816C35.4173 34.2448 36.7679 34.474 37.9865 35.0447"
            stroke="#243251"
            strokeWidth="1.47036"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M57.1179 46.0574C58.6291 46.0574 59.8542 44.8324 59.8542 43.3212C59.8542 41.81 58.6291 40.5849 57.1179 40.5849C55.6067 40.5849 54.3817 41.81 54.3817 43.3212C54.3817 44.8324 55.6067 46.0574 57.1179 46.0574Z"
            fill="#243251"
          />
          <Path
            opacity="0.61"
            d="M56.4649 42.9609C56.8505 42.9609 57.1631 42.6483 57.1631 42.2627C57.1631 41.8771 56.8505 41.5646 56.4649 41.5646C56.0794 41.5646 55.7668 41.8771 55.7668 42.2627C55.7668 42.6483 56.0794 42.9609 56.4649 42.9609Z"
            fill="white"
          />
          <Path
            d="M53.6725 35.7091C54.0554 35.1964 54.5607 34.7878 55.1422 34.5208C55.7237 34.2537 56.3629 34.1367 57.0013 34.1804C57.6397 34.2241 58.257 34.4271 58.7967 34.7708C59.3365 35.1146 59.7814 35.5882 60.0909 36.1483"
            stroke="#243251"
            strokeWidth="1.47036"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <G clipPath={clipUrl}>
            <G opacity="0.25">
              <Path
                opacity="0.25"
                d="M71.3527 33.6264C70.4895 31.1989 70.2738 29.3108 68.6554 26.7214C68.3857 26.2899 68.2778 25.6965 67.8462 25.3728C67.4147 25.0491 66.8213 25.0491 66.2279 25.0491C52.3639 25.4267 38.5 26.7214 24.7979 28.9332C23.5572 29.149 22.5322 30.12 21.2375 30.2279C19.5652 30.3897 18.4863 33.6264 18.4863 36.8631C27.1715 35.6763 36.558 33.4106 45.405 32.8712C49.7206 32.6015 54.0362 32.5475 58.3519 32.7093C59.7544 32.8172 70.975 32.4936 71.3527 33.6264Z"
                fill="#41A9CE"
              />
            </G>
            <Path
              d="M58.0822 6.54587C57.4348 5.79064 56.7335 4.98146 55.8165 4.49595C54.7915 3.90255 53.5508 3.68677 52.4179 3.52494C42.6538 2.06841 39.6329 1.31318 29.8148 2.33814C28.682 2.44603 21.6152 4.38806 20.6442 5.0354C19.835 5.57485 16.814 7.94845 16.3285 8.81157C9.15381 20.8953 10.934 27.153 9.8551 43.3365C16.3285 32.5475 15.2496 35.2447 16.868 28.2319C17.0838 27.2069 17.0838 25.157 17.9469 25.7504C18.2706 25.9662 18.4324 26.3438 18.5942 26.7214C19.0258 27.8003 19.4034 28.8792 19.6731 30.0121C27.1176 30.2278 31.0016 28.5016 38.4461 28.7713C44.8116 28.9871 63.2609 28.2319 67.0371 24.4557C71.8921 19.6006 61.4807 10.5918 58.0822 6.54587Z"
              fill="#C42D2D"
            />
            <Path
              d="M54.0902 29.3108C57.1111 29.041 67.5225 29.5265 70.2737 28.2319C73.025 26.9372 71.8921 24.9951 70.8132 21.7584C70.5974 21.0571 69.7882 19.4388 69.1948 19.0612C68.8172 18.8454 67.1449 19.4388 66.7134 19.4927C51.8784 21.5966 37.0974 23.7005 22.2625 25.7504C21.1296 25.9122 18.3245 26.5596 17.9469 27.6924C15.2496 35.2447 22.2085 32.8711 24.4203 32.5475C31.9726 31.4686 47.0233 29.9042 54.0902 29.3108Z"
              fill="white"
            />
            <Path
              d="M9.85507 49.2705C12.5365 49.2705 14.7101 47.0968 14.7101 44.4155C14.7101 41.7341 12.5365 39.5604 9.85507 39.5604C7.17369 39.5604 5 41.7341 5 44.4155C5 47.0968 7.17369 49.2705 9.85507 49.2705Z"
              fill="white"
            />
          </G>
        </G>
        <Defs>
          {isWeb ? (
            <filter
              id={filterId}
              x="0"
              y="0.852661"
              width="79"
              height="80.1473"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          ) : null}

          <LinearGradient
            id={gradientId}
            x1="18"
            y1="16"
            x2="76.7157"
            y2="68.9909"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#07FFB1" />
            <Stop offset="1" stopColor="#0FA6BF" />
          </LinearGradient>
          <ClipPath id={clipId}>
            <Rect
              width="67"
              height="47.4179"
              fill="white"
              transform="translate(5 1.85266)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
